export const JSON_ONE21= {
   
    "transaction_id": 119971,
    "me_id": "201712050001",
    "ag_id": "paygate",
    "order_no": "23870",
    "pg_id": 125,
    "paymode_id": "CC",
    "requested_paymode_id": "CC",
    "scheme_id": 1,
    "emi_months": 0,
    "unique_id": "",
    "address_count": 0,
    "item_value": "",
    "transaction_statusid": 119772,
    "sub_status": "18",
    "sub_status_description": "Refund Request Processed",
    "ag_ref": "1057244777503293440",
    "merchant_name": "Adidas",
    "merchant_address": "wagle ",
    "merchant_country": "IND ",
    "aggregator_name": "Paygate India Private Limited",
    "country_code": "AND",
    "currency_code": "EUR",
    "pg_name": "ICS PG",
    "transaction_date": "2018-10-30 17:46:12.0",
    "paymode_name": "Credit Card",
    "txn_type": "SALE",
    "success_url": "https://test.avantgardepayments.com/Adidas/MerchantSuccess.php",
    "failure_url": "https://test.avantgardepayments.com/Adidas/MerchantFailure.php",
    "channel": "WEB",
    "ip_address": "192.168.1.1",
    "server_name": "tomcat1",
    "cust_name": "tst",
    "email_id": "dipali@safexpay.com",
    "mobile_no": "9820258338",
    "is_logged_in": "Y",
    "bill_address": "",
    "bill_city": "",
    "bill_state": "",
    "bill_country": "",
    "bill_zip": "",
    "ship_address": "",
    "ship_city": "",
    "ship_state": "",
    "ship_zip": "",
    "item_category": "",
    "transaction_requestdate": "2018-10-30 17:46:12.0",
    "pg_ref": "584d505ba47b4357b197927b5bc38839",
    "status": "Refund",
    "remarks": "Approved",
    "transaction_statusdate": "2018-10-30 17:46:12.0",
    "fee": 0.4,
    "meIgst": 0.072,
    "meCgst": 0.9,
    "meSgst": 0.9,
    "agIgst": 0.9,
    "agCgst": 0.18,
    "agSgst": 0.18,
    "pgIgst": 0.9,
    "pgCgst": 0.9,
    "pgSgst": 0.9,
    "reIgst": 0.9,
    "reCgst": 0.9,
    "reSgst": 0.9,
    "ag_fee": 2,
    "amount": 10,
    "discount": 0,
    "pg_fee": 0.2,
    "re_fee": 0,
    "meNetAmount": 9.53,
    "meOtherTax1": 0,
    "meOtherTax2": 0,
    "meServiceTax": 0,
    "agNetAmount": 2,
    "agOtherTax1": 0,
    "agOtherTax2": 0,
    "agServiceTax": 0,
    "pgNetAmount": 9.8,
    "pgOtherTax1": 0,
    "pgOtherTax2": 0,
    "pgServiceTax": 0,
    "reNetAmount": 0,
    "reOtherTax1": 0,
    "reOtherTax2": 0,
    "reServiceTax": 0,
    "bank_response": "Approved"
        }

